import { IElementTypeEditInfo } from './../models/index'

export const uploadEditInfo: IElementTypeEditInfo = {
    editExcludeFields: []
}